import { FC } from "react";
import { useSignOut } from "~/hooks/useSignOut";
import { Trans } from "~/utils/i18next";
import { NavItemWrapper } from "./NavItemWrapper";

interface Props {
  onClick?: () => void;
}

export const SignOutNavItem: FC<Props> = ({ onClick }) => {
  const { handleSignOut } = useSignOut({ onClick });

  return (
    <NavItemWrapper onClick={handleSignOut}>
      <Trans i18nKey="navigation.signOut" />
    </NavItemWrapper>
  );
};
